module.exports = __webpack_public_path__ + "assets/prettyConfident.6b3f5312.svg";